import { c as _c } from "react/compiler-runtime";
import React from "react";
interface DirectionIconProps {
  className?: string;
  size?: number;
  rotate?: number;
  strokeWidth?: string;
}
const DirectionIcon = t0 => {
  const $ = _c(9);
  const {
    className,
    size: t1,
    rotate: t2,
    strokeWidth: t3
  } = t0;
  const size = t1 === undefined ? 24 : t1;
  const rotate = t2 === undefined ? 0 : t2;
  const strokeWidth = t3 === undefined ? "1.5" : t3;
  const t4 = `dynamic-size ${className}`;
  const t5 = `rotate(${rotate}deg)`;
  let t6;
  if ($[0] !== size || $[1] !== t5) {
    t6 = {
      "--width": size,
      "--height": size,
      transform: t5
    };
    $[0] = size;
    $[1] = t5;
    $[2] = t6;
  } else {
    t6 = $[2];
  }
  const t7 = t6 as React.CSSProperties;
  let t8;
  if ($[3] !== strokeWidth) {
    t8 = <path d="M20 8L12 16L4 8" stroke="currentColor" strokeWidth={strokeWidth} />;
    $[3] = strokeWidth;
    $[4] = t8;
  } else {
    t8 = $[4];
  }
  let t9;
  if ($[5] !== t4 || $[6] !== t7 || $[7] !== t8) {
    t9 = <svg className={t4} style={t7} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">{t8}</svg>;
    $[5] = t4;
    $[6] = t7;
    $[7] = t8;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  return t9;
};
export default DirectionIcon;